export const checkGroupId = (tokenId)=>{
  
    if(tokenId >= 0 && tokenId <  800){
        return 0;
    }
    else if (tokenId >= 800 && tokenId < 1600){
        return 1;
    }
    else if (tokenId >= 1600 && tokenId < 2000){
        return 2;
    }
    else if(tokenId >=2000 && tokenId < 2300){
        return 3;
    }
    else if (tokenId >= 2300 && tokenId < 2400){
        return 4;
    }else{
        return 5;
    }
}